var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#e3e3e3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132.12-132.12v-62.84l55.96-55.96v118.8h-55.96Zm160 0v-222.84l55.96-55.96v278.8h-55.96Zm160 0v-278.8l55.96 56.96v221.84h-55.96Zm160 0v-221.84l55.96-55.96v277.8h-55.96Zm160 0v-382.84l55.96-55.96v438.8h-55.96Zm-640-223.96v-78.88L400-703.04l160 160 268.08-267.88v78.88L560-464.15l-160-160-267.88 268.07Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.82dcf3cf.svg";
export { ForwardRef as ReactComponent };